<template>
  <Menu></Menu>
  <div id="box">
    <div v-if="loading" class="loadingSpinner"><span class="spinner-border"></span></div>
    <!-- =========================================================================================================== -->
    <div class="container mb-2">
      <div class="row p-0">
        <div class="col p-0 text-center">
          <h5 class="fw-bold d-inline-block bi-wrench">&nbsp; Manage Settings</h5>
          <hr>
        </div>
      </div>
          
      <div class="row p-0">
        <div class="col p-0"></div>
        <div class="col p-0"></div>
        <div class="col p-0">
          <button class="btn btn-success w-100" @click="saveTweaks()" :disabled="loading">
            <span class="bi-floppy">&nbsp; Save</span>
          </button>
        </div>
      </div>


      <div class="row p-0">
        <div class="col p-0">
          <div class="input-group w-100 mb-2">
            <span class="input-group-text w-50">Alarm Stock</span>
            <input class="form-control text-center" type="number" v-model="alarm">
          </div>
        </div>         
        <div class="col p-0"></div>
        <div class="col p-0"></div>
      </div>

      <div class="row p-0">
        <div class="col p-0">
          <div class="input-group w-100 mb-2">
            <span class="input-group-text w-50">Tax 0 - 100</span>
            <input class="form-control text-center" type="number" v-model="tax">
            <span class="input-group-text">%</span>
          </div>
        </div>   
        <div class="col p-0"></div>
        <div class="col p-0"></div>
      </div>

      <div class="row p-0">
        <div class="col p-0">
          <div class="input-group w-100 mb-2">
            <span class="input-group-text w-50">Wholesaler Rate 0 - 100</span>
            <input class="form-control text-center" type="number" v-model="ws_rate">
            <span class="input-group-text">%</span>
          </div>
        </div>   
        <div class="col p-0"></div>
        <div class="col p-0"></div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
  </div>

</template>
<!-- ******************************************************** -->
<script>
  export default {
    name: 'SettingsPage',
    data(){
      return {
        loading: false,
        alarm: '',
        tax: '',
        ws_rate: '',
      }
    },
    created() {
      this.reloadData();
    },
    //**********************************************************
    methods:{
      //**********************************************************
      async reloadData(){
        this.loading = true;
        this.tax = this.alarm = '';
        var ack = await this.$service.getTweaks();
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.tax = ack.data.tax.value;
          this.alarm = ack.data.alarm.value;
          this.ws_rate =  ack.data.ws_rate.value;
        }
        this.loading = false;
      },
      //**********************************************************
      //**********************************************************
      async saveTweaks(){
        this.loading = true;
        await this._saveTweaks();
        this.loading = false;
      },
      //**********************************************************
      async _saveTweaks(){
        if(!this.alarm || this.tax === '' || isNaN(this.tax) || isNaN(this.ws_rate)){
          return this.$toast('Some Fields are empty', 'warning');
        }
        var ack = await this.$service.setTweaks({
          alarm: this.alarm,
          tax: this.tax,
          ws_rate: this.ws_rate,
        });
        if(ack.state != 'OK') return this.$toast(ack.state);
        this.$toast('Tweaks Saved Successfuly', 'success');
        this.reloadData();
      },
      //**********************************************************
      //**********************************************************
      //**********************************************************
      //**********************************************************
      //**********************************************************
    }
  }
</script>
<!-- ******************************************************** -->
<style scoped>
</style>
  